exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-scroll[data-v-611281fd]::-webkit-scrollbar-track {\n  border: 1px solid #000;\n  padding: 2px 0;\n  background-color: #404040;\n}\n.custom-scroll[data-v-611281fd]::-webkit-scrollbar {\n  width: 10px;\n}\n.custom-scroll[data-v-611281fd]::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n          box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n  background-color: #00BCD4;\n  border: 1px solid #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-611281fd","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/ProfessionalWithHoldingTax.vue
// module id = 2024
// module chunks = 0